var _a;
export var DIRECTION_LEFT = 'ArrowLeft';
export var DIRECTION_RIGHT = 'ArrowRight';
export var DIRECTION_UP = 'ArrowUp';
export var DIRECTION_DOWN = 'ArrowDown';
export var KEY_ENTER = 'Enter';
export var KEY_EXIT = 'End';
export var KEY_BACK = 'Back';
export var KEY_BACK_ANDROID_TV = 'AndroidTvBack';
export var KEY_BACK_TIZEN_TV = 'TizenBack';
export var KEY_BACK_WEBOS_TV = 'WebOSBack';
export var KEY_CODE = {
    LEFT: 37,
    RIGHT: 39,
    UP: 38,
    DOWN: 40,
    OK: 13,
    ENTER: 13,
    DONE: 65376,
    BACK: 27,
    ANDROID_TV_BACK: 300,
    TIZEN_BACK: 10009,
    WEBOS_BACK: 461,
    EXIT: 35,
    TIZEN_MEDIA_PLAY: 415,
    TIZEN_MEDIA_PAUSE: 19,
    TIZEN_MEDIA_STOP: 413,
    TIZEN_MEDIA_PLAY_PAUSE: 10252,
    MEDIA_FAST_FORWARD: 417,
    MEDIA_REWIND: 412, // TIZEN + WEBOS TV : "REWIND"
};
export var DEFAULT_KEY_MAP = (_a = {},
    _a[DIRECTION_LEFT] = KEY_CODE.LEFT,
    _a[DIRECTION_UP] = KEY_CODE.UP,
    _a[DIRECTION_RIGHT] = KEY_CODE.RIGHT,
    _a[DIRECTION_DOWN] = KEY_CODE.DOWN,
    _a[KEY_ENTER] = KEY_CODE.ENTER,
    _a[KEY_BACK] = KEY_CODE.BACK,
    _a[KEY_BACK_TIZEN_TV] = KEY_CODE.TIZEN_BACK,
    _a[KEY_BACK_WEBOS_TV] = KEY_CODE.WEBOS_BACK,
    _a[KEY_BACK_ANDROID_TV] = KEY_CODE.ANDROID_TV_BACK,
    _a[KEY_EXIT] = KEY_CODE.EXIT,
    _a);
export var PARENT_FOCUS_KEY = 'TVING_PARENT';
export var ROOT_FOCUS_KEY = 'TVING_ROOT';
export var ADJACENT_SLICE_THRESHOLD = 0.2;
/**
 * Adjacent slice is 5 times more important than diagonal
 */
export var ADJACENT_SLICE_WEIGHT = 5;
export var DIAGONAL_SLICE_WEIGHT = 1;
/**
 * Main coordinate distance is 5 times more important
 */
export var MAIN_COORDINATE_WEIGHT = 5;
export var DEBUG_FN_COLORS = ['#0FF', '#FF0', '#F0F'];
export var THROTTLE_OPTIONS = {
    leading: true,
    trailing: false,
};
export var CHILDREN_ENDPOINT_ACTION_RESULT;
(function (CHILDREN_ENDPOINT_ACTION_RESULT) {
    CHILDREN_ENDPOINT_ACTION_RESULT["NONE"] = "NONE";
    CHILDREN_ENDPOINT_ACTION_RESULT["ISOLATED"] = "ISOLATED";
    CHILDREN_ENDPOINT_ACTION_RESULT["LOOP"] = "LOOP";
})(CHILDREN_ENDPOINT_ACTION_RESULT || (CHILDREN_ENDPOINT_ACTION_RESULT = {}));
export var CHILDREN_ENDPOINT_ACTION;
(function (CHILDREN_ENDPOINT_ACTION) {
    CHILDREN_ENDPOINT_ACTION["NONE"] = "NONE";
    CHILDREN_ENDPOINT_ACTION["ISOLATED"] = "ISOLATED";
    CHILDREN_ENDPOINT_ACTION["LOOP_ALL"] = "LOOP_ALL";
    CHILDREN_ENDPOINT_ACTION["LOOP_VERTICAL"] = "LOOP_VERTICAL";
    CHILDREN_ENDPOINT_ACTION["LOOP_HORIZON"] = "LOOP_HORIZON";
    CHILDREN_ENDPOINT_ACTION["LOOP_RIGHT"] = "LOOP_RIGHT";
    CHILDREN_ENDPOINT_ACTION["LOOP_LEFT"] = "LOOP_LEFT";
    CHILDREN_ENDPOINT_ACTION["LOOP_UP"] = "LOOP_UP";
    CHILDREN_ENDPOINT_ACTION["LOOP_DOWN"] = "LOOP_DOWN";
})(CHILDREN_ENDPOINT_ACTION || (CHILDREN_ENDPOINT_ACTION = {}));
